import React from 'react'
import Samples from './Samples'
import OlympInfo from './OlympInfo'

const Info = ({ global, ...rest }) => {
  return (
    <div className="info-section">
      <Samples examples={global.examples} />
      <OlympInfo {...rest} />
    </div>
  )
}

export default Info
